module.exports = __webpack_public_path__ + "img/logo.17d6716c.png";